/** Minimal project identity for URLs and API path segments. */
export type ProjectRouteRef = { number: number; id?: string } | { id: string; number?: number };

/** Public segment for /api/projects/:id and ?project= — numeric when present, else legacy UUID. */
export function projectApiParam(project: ProjectRouteRef): string {
  if ('number' in project && project.number !== undefined && project.number !== null) {
    return String(project.number);
  }
  if ('id' in project && project.id) return project.id;
  throw new Error('Project route ref must include number or id');
}
